/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { BurgerBar, BurgerHiddenText, BurgerWrapper } from './BurgerMenu.style';

var BurgerMenu = function BurgerMenu(_ref) {
  var toggle = _ref.toggle,
      isExpandable = _ref.isExpandable;
  return React.createElement(BurgerWrapper, {
    href: "#",
    role: "button",
    "aria-haspopup": "true",
    "aria-label": "Open and close Navigation Menu",
    inline: true,
    underline: false,
    onClick: toggle,
    isExpandable: isExpandable
  }, React.createElement(BurgerHiddenText, null, "Open and close nav menu"), React.createElement(BurgerBar, null));
};

export default BurgerMenu;